import BaseAPI from "../base";
import moment from "moment";
import { generateRandomString } from "@/utils/utils";
const CryptoJS = require("crypto-js");
class ReportsService extends BaseAPI {
  // 列表接口
  getCanSellTimeListApi(param) {
    const timestamp = moment().valueOf()
    const nonce = generateRandomString()
    const cryptoData = 'canSell' + nonce + timestamp
    const sign = CryptoJS.MD5(cryptoData).toString()
    return this.post({
      url: `${process.env.VUE_APP_DSP_APIBASEURL}/dsp-customer/cansell/canSellTimeList`,
      headers: {
        username: 'canSell',
        timestamp: timestamp,
        nonce: nonce,
        sign: sign
      },
      data: {
        ...param
      }
    });
  }
  // 渠道
  getChannelListApi(param) {
    return this.get({
      url: `${process.env.VUE_APP_DSP_APIBASEURL}/dsp-customer/institution/getInstitutionChannel?name=${param.name}`,
    });
  }
  // 二级
  getChannelSecondListApi(param) {
    return this.get({
      url: `${process.env.VUE_APP_DSP_APIBASEURL}/dsp-customer/cansell/getInstitutionSecond?name=${param.name}&key=${param.key}`,
    });
  }
  // 三级
  getChannelThreeListApi(key) {
    return this.get({
      url: `${process.env.VUE_APP_DSP_APIBASEURL}/dsp-customer/cansell/getInstitutionThreeLevel?key=${key}`,
    });
  }
  // 提交表单接口
  submitCanSellApi(param) {
    const timestamp = moment().valueOf()
    const nonce = generateRandomString()
    const cryptoData = 'canSell' + nonce + timestamp
    const sign = CryptoJS.MD5(cryptoData).toString()
    return this.post({
      url: `${process.env.VUE_APP_DSP_APIBASEURL}/dsp-customer/cansell/submit`,
      headers: {
        username: 'canSell',
        timestamp: timestamp,
        nonce: nonce,
        sign: sign
      },
      data: {
        ...param
      }
    });
  }
  // 详情接口
  detailCanSellApi(param) {
    const timestamp = moment().valueOf()
    const nonce = generateRandomString()
    const cryptoData = 'canSell' + nonce + timestamp
    const sign = CryptoJS.MD5(cryptoData).toString()
    return this.post({
      url: `${process.env.VUE_APP_DSP_APIBASEURL}/dsp-customer/cansell/canSellDetails`,
      headers: {
        username: 'canSell',
        timestamp: timestamp,
        nonce: nonce,
        sign: sign
      },
      data: {
        ...param
      }
    });
  }
  // 用户基础信息接口
  getUserApi(val) {
    const timestamp = moment().valueOf()
    const nonce = generateRandomString()
    const cryptoData = 'canSell' + nonce + timestamp
    const sign = CryptoJS.MD5(cryptoData).toString()
    return this.get({
      url: `${process.env.VUE_APP_DSP_APIBASEURL}/dsp-customer/cansell/getBaseData?dinUserId=${val}`,
      headers: {
        username: 'canSell',
        timestamp: timestamp,
        nonce: nonce,
        sign: sign
      },
    });
  }
  // 回款录入
  collectionInputApi(param) {
    const timestamp = moment().valueOf()
    const nonce = generateRandomString()
    const cryptoData = 'canSell' + nonce + timestamp
    const sign = CryptoJS.MD5(cryptoData).toString()
    return this.post({
      url: `${process.env.VUE_APP_DSP_APIBASEURL}/dsp-customer/cansell/collectionInput`,
      headers: {
        username: 'canSell',
        timestamp: timestamp,
        nonce: nonce,
        sign: sign
      },
      data: {
        ...param
      }
    });
  }
}


export default new ReportsService();
